import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import Switch from '@material-ui/core/Switch';
import { Button, Snackbar, TextField, FormControlLabel, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import SaveIcon from '@material-ui/icons/Save';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

//Card
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

//Stepper

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';



//Merge
var merge = require('lodash.merge');
var unset = require('lodash.unset');

const theme = createMuiTheme({});

const useStyles = makeStyles(theme => ({
    div: {
        marginRight: '15px',
        // float: 'right',
    },

    //Stepper
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepperdiv: {
        marginRight: '15px',
        float: 'right',
    },

    //Accordion
    heading: {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightRegular,
    },
    //card
    cardroot: {
        minHeight: 465,
        height: '100%',
    },
}));

//Stepper

function getSteps() {
    return ['Header Config', 'Thumbnail & Business Actions Config'];
}

//Alert

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EntityHeaderForm(props) {
    const classes = useStyles();
    const { location, history } = useReactRouter();
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const dispatch = useDispatch();

    //success alert

    const [openalert, setOpenAlert] = React.useState({
        open: false,
        msg: 'Configuration Saved',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({
            open: false,
        });
    };

    //Stepper
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();


    //Header static JSON

    const [jsonObj] = React.useState({
        _id: '',
        componentContextCode: '',
        domain: '',
        entityType: '',
        context1: '',
        context2: '',
        context3: '',
        relationship: '',
        role: '',
        app: '',
        isDuplicate: '',
        environmentId: '',
        isDuplicate: false,
        isPublished: true,
        jsonDocument: {
            id: "",
            name: "",
            type: "",
            // properties:"",
            data: {
                contexts: [{
                    context: {
                        component: "_DEFAULT",
                        role: "_DEFAULT",
                        tenant: "_DEFAULT",
                        domain: "_DEFAULT",
                        app: "_DEFAULT",
                        entityType: "_DEFAULT",
                        country: "_DEFAULT",
                        channel: "_DEFAULT",
                        relationship: "_DEFAULT",
                        user: "_DEFAULT"
                    },
                    jsonData: {}
                }]
            }
        }
    })

    const handleNext = (event) => {
        if (event === 'Next') {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setOpenNextSelection({
                open: true
            })

        }
        else {
            reduxAuth.fullscreentoggle=false
            history.push('./Config')
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setOpenNextSelection({
            open: false
        })
    };
    //End Stepper

    const [openNextSelection, setOpenNextSelection] = React.useState({
        open: false
    })

    //Error Part
    const [labelError, setLabelError] = React.useState({
        error: true,
        label: "Label is required.",
        helperText: "Label is required.",
        validateInput: true,
    });

    const [nameError, setNameError] = React.useState({
        error: true,
        label: "Attribute Name is required.",
        helperText: "Attribute Name is required.",
        validateInput: true,
    });

    //TenantAttribute List
    const [TenantAttributes, setTenantAttributes] = React.useState(appcomponent.attributeList)

    //Columns
    const [state, setState] = React.useState({
        columns: [
            {
                title: '', render: rowData => {
                    if (rowData) {
                        if (rowData.isMetadataAttribute != true) {
                            return <DeleteOutlineIcon onClick={(event) => handledeleteattribute(rowData)}></DeleteOutlineIcon>
                        }
                    }
                }
            },
            {
                title: 'Attribute Name', field: 'attributeName', editable: 'onAdd',
                cellStyle: {
                    width: 200,
                    minWidth: 200
                },
                editComponent: props => (
                    <Autocomplete
                        id="Select Attribute"
                        name="Select Attribute"
                        size="small"
                        options={TenantAttributes}
                        onChange={(e, value) => {
                            if (nameError.validateInput) {
                                setNameError({
                                    ...nameError,
                                    validateInput: false,
                                });
                            }

                            props.onChange(value);
                        }}

                        getOptionLabel={option => option}
                        renderInput={params => (
                            <TextField
                                fullWidth
                                {...params}
                                variant="standard"
                                label="Select Attribute"
                                size="small"
                                placeholder="Select Attribute"
                                error={
                                    !props.value &&
                                        nameError.validateInput
                                        ? nameError.error
                                        : false
                                }
                                helperText={
                                    !props.value &&
                                        nameError.validateInput
                                        ? nameError.helperText
                                        : ""
                                }
                            />
                        )}
                        value={props.value ? props.value : ""}
                    />
                )
            },
            {
                title: 'Attribute Label', field: 'label',
                cellStyle: {
                    width: 200,
                    minWidth: 200
                },
                editComponent: (props) => (
                    <TextField
                        type="text"
                        placeholder="Label"
                        error={
                            !props.value &&
                                labelError.validateInput
                                ? labelError.error
                                : false
                        }
                        helperText={
                            !props.value &&
                                labelError.validateInput
                                ? labelError.helperText
                                : ""
                        }
                        value={props.value ? props.value : ""}
                        onChange={(e) => {
                            if (labelError.validateInput) {
                                setLabelError({
                                    ...labelError,
                                    validateInput: false,
                                });
                            }

                            props.onChange(e.target.value);
                        }}
                    />
                ),
            },
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handleheaderattribute(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handleheaderattribute(rowData)
                        }} />
                    }
                }
            },
            {
                title: 'No Trim',
                field: 'noTrim',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.noTrim === "true" || rowData.noTrim === true) {

                        return <Switch checked={rowData.noTrim} onChange={(event) => {
                            rowData.noTrim = false
                            handleheaderattribute(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.noTrim} onChange={(event) => {
                            rowData.noTrim = true
                            handleheaderattribute(rowData)
                        }} />
                    }
                }
            },

        ]
    });

    //Thmbnail config
    const [ThmbnailConfig, setThmbnailConfig] = React.useState({
        "thumbnailConfig": {
            "relationshipName": "",
            "relationshipFilterAttributeName": "",
            "relationshipFilterAttributeValue": true,
            "hideEntityThumbnail": false
        }
    })

    //BusinessActionConfig
    const [BusinessActionsConfig, setBusinessActionsConfig] = React.useState({
        "businessActionsConfig": {
            "showActions": true,
            "title": "{[BATxt]}",
            "messageAttribute": "id"
        }
    })

    //handlebaswitch

    const handlebaswitch = (event, value) => {
        var varbaconfig = BusinessActionsConfig.businessActionsConfig;
        let newbaconfig = {
            [event.currentTarget.id]: value
        }
        let mergebaconfig = merge(varbaconfig, newbaconfig)
        setBusinessActionsConfig({
            ...BusinessActionsConfig,
            "businessActionsConfig": mergebaconfig
        })
    }

    //handlebatxt
    const handlebatxt = (event) => {
        var varbaconfig = BusinessActionsConfig.businessActionsConfig;
        let newbaconfig = {
            [event.currentTarget.name]: event.currentTarget.value
        }
        let mergebaconfig = merge(varbaconfig, newbaconfig)
        setBusinessActionsConfig({
            ...BusinessActionsConfig,
            "businessActionsConfig": mergebaconfig
        })
    }

    //handlethumbnailtextbox
    const handlethumbnailtextbox = (event) => {

        var varthumbnailconfig = ThmbnailConfig.thumbnailConfig;
        let newthumbnailconfig = {
            [event.currentTarget.name]: event.currentTarget.value
        }
        let mergethumbnailconfig = merge(varthumbnailconfig, newthumbnailconfig)
        setThmbnailConfig({
            ...ThmbnailConfig,
            "thumbnailConfig": mergethumbnailconfig
        })
    }

    //handlethubnailswitch
    const handlethubnailswitch = (event, value) => {
        var varthumbnailconfig = ThmbnailConfig.thumbnailConfig;
        let newthumbnailconfig = {
            [event.currentTarget.id]: value
        }
        let mergethumbnailconfig = merge(varthumbnailconfig, newthumbnailconfig)
        setThmbnailConfig({
            ...ThmbnailConfig,
            "thumbnailConfig": mergethumbnailconfig
        })
    }

    //AttributeList
    const [AttributeList, setAttributeList] = React.useState([])

    //handleheaderattribute
    const handleheaderattribute = (newData) => {
        var oldlist = AttributeList;
        var newlist = oldlist.concat(newData);
        let addjson = {
            "config": {
                "headerConfig": {
                    [newData.attributeName]: newData
                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getAttributeList();
                updateConfigAPI();

            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
            }
        }

        if (location.state === undefined) {

            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            getAttributeList();
            updateConfigAPI("add");
            // history.push("./ManageConfig")

        }
    }

    //handledeleteattribute
    const handledeleteattribute = (rowData) => {
        let config = location.state.jsonDocument.data.contexts[0].jsonData.config.headerConfig;
        let del = unset(config, rowData.attributeName)
        location.state.jsonDocument.data.contexts[0].jsonData.config.headerConfig = config
        getAttributeList();
        updateConfigAPI();
    }

    //handleSaveClick
    const handleSaveClick = () => {
        let mergejson = null;
        let addjson1 = {
            "config": ThmbnailConfig
        }
        let addjson2 = {
            "config": BusinessActionsConfig
        }
        let addjson = merge(addjson1, addjson2);
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                updateConfigAPI();
            }

            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
            }
        }

        if (location.state === undefined) {

            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            updateConfigAPI("add");
            // history.push("./ManageConfig")

        }
    }

    //update config API
    const updateConfigAPI = (event) => {

        //update Config

        let url = "configurationUpdate"
        let postdata = null;
        if (event === "add") {
            postdata = {
                _id: props.data._id,
                jsonDocument: jsonObj.jsonDocument,
                isPublished: false,
                componentContextCode: props.data.componentContextCode,
                domain: props.data.domain,
                entityType: props.data.entityType,
                context1: props.data.context1,
                context2: props.data.context2,
                context3: props.data.context3,
                relationship: props.data.relationship,
                role: props.data.role,
                app: props.data.app,
                isDuplicate: props.data.isDuplicate,
                environmentId: props.data.environmentId,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            };
        }
        else {
            location.state.isPublished = false;
            postdata = {
                ...location.state,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            }
        }


        axios.post(url, postdata)
            .then(editConfigResponse => {
                setOpenAlert({
                    open: true
                })
            })
            .catch(err => {
                console.log(err);
                if (typeof err.response != "object") {
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });

    }
    //getAttributeList
    const getAttributeList = () => {
        let baseconfig = null;
        let mapconfig = null;
        let url = "baseConfigurationGet"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
            componentContextCode: appcomponent.selectedComponent.componentContextCode
        }

        axios.post(url, postdata)
            .then(baseConfigResponse => {
                baseconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.headerConfig;
                mapconfig = baseconfig;
                if (location.state) {
                    if (location.state.jsonDocument != '') {
                        try {
                            if (location.state.jsonDocument.data.contexts[0].jsonData.config.hasOwnProperty("headerConfig")) {
                                if (location.state.jsonDocument.data.contexts[0].jsonData.config.headerConfig != {}) {
                                    let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.headerConfig;
                                    mapconfig = merge(baseconfig, customconfig)
                                }
                                else {
                                    mapconfig = baseconfig;
                                }
                            }
                            else {
                                mapconfig = baseconfig;
                            }
                        } catch (error) {
                            mapconfig = baseconfig;
                        }
                    }
                }
                if (location.state === undefined) {
                    mapconfig = baseconfig
                }

                let attributelist = Object.keys(mapconfig).map((key) => {
                    return mapconfig[key]
                })

                setAttributeList(attributelist)
            })
    }

    //getThumbnailConfig
    const getThumbnailConfig = () => {
        if (location.state) {
            if (location.state.jsonDocument != '') {
                try {
                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.hasOwnProperty("thumbnailConfig")) {
                        setThmbnailConfig({
                            ...ThmbnailConfig,
                            "thumbnailConfig": location.state.jsonDocument.data.contexts[0].jsonData.config.thumbnailConfig
                        })
                    }
                } catch (error) { }

            }
        }
    }

    //getBusinessActionsConfig
    const getBusinessActionsConfig = () => {
        if (location.state) {
            if (location.state.jsonDocument != '') {
                try {
                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.hasOwnProperty("businessActionsConfig")) {
                        setBusinessActionsConfig({
                            ...BusinessActionsConfig,
                            "businessActionsConfig": location.state.jsonDocument.data.contexts[0].jsonData.config.businessActionsConfig
                        })
                    }
                } catch (error) { }

            }
        }
    }

    useEffect(() => {

        getAttributeList();

        getThumbnailConfig();

        getBusinessActionsConfig();

    }, []);

    return (
        <div>
            {openalert.open ?
                <Snackbar
                    open={openalert.open} autoHideDuration={3000}
                    onClose={handleClose}>
                    <Alert
                        severity={"success"}
                        color={"info"}
                        variant="outlined">
                        Configuration Saved..
                        </Alert>
                </Snackbar>
                : null}
            {appcomponent.attributeList == null ?
                <Snackbar
                    open={true} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    onClose={handleClose}>
                    <Alert
                        severity="error"
                        color="error"
                        variant="filled">
                        Couldn't found context list please sync the tenant...
                     </Alert>
                </Snackbar>
                : null}
            <div className={classes.root}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className={classes.stepperdiv}>
                    {activeStep === steps.length ? null : (
                        <div>
                            <div>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    className={classes.backButton}
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    startIcon={<ArrowBackIosIcon style={{ fontSize: 10 }} />}
                                >
                                    Back
                                 </Button>
                                <Button variant="contained"
                                    size="small"
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    color="primary"
                                    onClick={() => handleNext(activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next')}
                                    startIcon={activeStep === steps.length - 1 ? <SettingsBackupRestoreIcon /> : <NavigateNextIcon />}
                                >
                                    {activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next'}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openNextSelection.open ?
                <div style={{ marginTop: '40px' }}>
                    <Card className={classes.cardroot}>
                        <CardContent>
                            <Typography className={classes.heading}>Thumbnail Config</Typography>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleSaveClick()}
                                className={classes.backButton}
                                style={{ fontSize: '0.600rem', fontWeight: 600, float: 'right', top: 0 }}
                                startIcon={<SaveIcon />}>
                                Save
                                 </Button>
                            <br></br><br></br>
                            <TextField
                                name="relationshipName"
                                style={{ width: '45%' }}
                                variant="outlined"
                                label="Relationship Name"
                                size="small"
                                placeholder="Relationship Name"
                                value={ThmbnailConfig.thumbnailConfig.relationshipName}
                                onChange={handlethumbnailtextbox}
                            />

                            <TextField
                                name="relationshipFilterAttributeName"
                                style={{ width: '45%', marginLeft: "5%" }}
                                variant="outlined"
                                label="Relationship Filter Attribute Name"
                                size="small"
                                placeholder="Relationship Filter Attribute Name"
                                value={ThmbnailConfig.thumbnailConfig.relationshipFilterAttributeName}
                                onChange={handlethumbnailtextbox}
                            />
                            <br></br><br></br>
                            <FormControlLabel
                                style={{ width: '45%', marginLeft: '5px', border: '1px solid', borderRadius: '5px' }}
                                value="relationshipFilterAttributeValue"
                                control={<Switch id="relationshipFilterAttributeValue" color="primary" checked={ThmbnailConfig.thumbnailConfig.relationshipFilterAttributeValue} />}
                                label="Relationship Filter Attribute Value"
                                labelPlacement="end"
                                onChange={handlethubnailswitch}
                            />

                            <FormControlLabel
                                style={{ width: '45%', marginLeft: "15px", border: '1px solid', borderRadius: '5px' }}
                                value="hideEntityThumbnail"
                                control={<Switch id="hideEntityThumbnail" color="primary" checked={ThmbnailConfig.thumbnailConfig.hideEntityThumbnail} />}
                                label="Hide Entity Thumbnail"
                                labelPlacement="end"
                                onChange={handlethubnailswitch}
                            />
                            <br></br><br></br>
                            {/* Business Actions Config */}
                            <Typography className={classes.heading}>Business Actions Config</Typography>
                            <br></br>
                            <FormControlLabel
                                style={{ width: '45%', marginLeft: "5px", border: '1px solid', borderRadius: '5px' }}
                                value="showActions"
                                control={<Switch id="showActions" color="primary" checked={BusinessActionsConfig.businessActionsConfig.showActions} />}
                                label="Show Actions"
                                labelPlacement="end"
                                onChange={handlebaswitch}
                            />
                            <TextField
                                name="title"
                                style={{ width: '45%', marginLeft: "15px" }}
                                variant="outlined"
                                label="Title"
                                size="small"
                                placeholder="title"
                                value={BusinessActionsConfig.businessActionsConfig.title}
                                onChange={handlebatxt}
                            />
                            <br></br><br></br>
                            <TextField
                                name="messageAttribute"
                                style={{ width: '45%', marginLeft: "5px" }}
                                variant="outlined"
                                label="Message Attribute"
                                size="small"
                                placeholder="messageAttribute"
                                value={BusinessActionsConfig.businessActionsConfig.messageAttribute}
                                onChange={handlebatxt}
                            />
                        </CardContent>
                    </Card>
                </div> :
                <div style={{ marginTop: '40px' }}>

                    <MaterialTable
                        title="Header Attributes"
                        columns={state.columns}
                        data={AttributeList}
                        options={{
                            search: true,
                            sorting: true,
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100],
                            padding: 'dense'
                        }}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        if (!newData.label) {
                                            setLabelError({
                                                error: true,
                                                label: "required",
                                                helperText: "Label is required.",
                                                validateInput: true,
                                            });
                                            reject();
                                            return;
                                        }
                                        if (!newData.attributeName) {
                                            setNameError({
                                                error: true,
                                                label: "required",
                                                helperText: "Attribute Name is required.",
                                                validateInput: true,
                                            });
                                            reject();
                                            return;
                                        }
                                        resolve();
                                        handleheaderattribute(newData);
                                    }, 600);
                                }),
                            onRowUpdate: (newData) =>
                                new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        if (!newData.label) {
                                            setLabelError({
                                                error: true,
                                                label: "required",
                                                helperText: "Label is required.",
                                                validateInput: true,
                                            });
                                            reject();
                                            return;
                                        }

                                        resolve();
                                        handleheaderattribute(newData);
                                    }, 600);
                                })
                        }}

                    /></div>
            }
        </div>
    )
}